import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import React, { useCallback, useState } from 'react';
import {
  BoardCategory,
  boardCategory,
  BoardPost,
  boardPostWithDefault,
} from '../types/board';
import { memoNamed } from '../utils/react/memo-named';
import { BoardViewInfo } from './BoardViewInfo';
import { Button, ButtonGroup } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { H3 } from './common/styled';
interface Props {
  isAdmin: boolean;
  category: BoardCategory;
  setCategory: (category: BoardCategory) => void;
  postInfoList: readonly { post: BoardPost; docID: string }[];
  setPostInfoList: (
    fn: (
      postInfoList: { post: BoardPost; docID: string }[]
    ) => { post: BoardPost; docID: string }[]
  ) => void;
  startKeyNext: firebase.firestore.Timestamp;
  setStartKeyNext: (postTime: firebase.firestore.Timestamp) => void;
  updatePost: () => void;
}
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
  })
);

export const BoardView = memoNamed<Props>('BoardView', (props) => {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  
  const morePost = useCallback(() => {
    const db = firebase.firestore();
    setIsLoading(true);
    db.collection('Board')
      .where('isPublic', '==', true)
      .where('category', '==', props.category)
      .orderBy('postTime', 'desc')
      .startAfter(props.startKeyNext)
      .limit(10)
      .get()
      .then((snapshot) => {
        props.setPostInfoList((postInfoList) =>
          postInfoList.concat(
            snapshot.docs.map((u, i) => {
              const _post = boardPostWithDefault(u.data() as object);
              const docID = u.id;
              if (i === snapshot.docs.length - 1)
                props.setStartKeyNext(_post.postTime);
              return { post: _post, docID: docID };
            })
          )
        );
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, [props]);

  return (
    <div>
      <H3>カテゴリー</H3>
      <div className={classes.root}>
        <ButtonGroup color='primary' aria-label='outlined primary button group'>
          {boardCategory.map((u, i) => (
            <Button
              variant={props.category === u.key ? 'contained' : undefined}
              key={i}
              onClick={() => props.setCategory(u.key)}
            >
              {u.name}
            </Button>
          ))}
        </ButtonGroup>
      </div>
      <br />
      {props.postInfoList.map((postInfo) => (
        <div key={postInfo.docID}>
          <BoardViewInfo
            key={postInfo.docID}
            postInfo={postInfo}
            setPostInfoList={props.setPostInfoList}
            isAdmin={props.isAdmin}
          />
          <br />
        </div>
      ))}
      <br />
      {!isLoading ? (
        <Button variant='contained' onClick={morePost}>
          さらに投稿を表示
        </Button>
      ) : (
        '通信中...'
      )}
    </div>
  );
});
